import { useCallback } from "react";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import { useRecoilValue } from "recoil";
import {
  MY_HR_CONTRACTS_SUBSCRIPTION,
  MY_HR_GET_CONTRACTS_BY_EMPLOYEE,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";
import { twoFaVerificationPendingState } from "oc/states";

export const useMyHrContractsByEmployee = ({
  employee,
}: {
  employee: string;
}) => {
  const pollInterval = useOcPolling(1000 * 60);
  const twoFaVerificationPending = useRecoilValue(twoFaVerificationPendingState);

  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_CONTRACTS_BY_EMPLOYEE,
    {
      fetchPolicy: "cache-and-network",
      skip: !employee || twoFaVerificationPending, // Skip during 2FA flow
      pollInterval,
      variables: { employee },
    },
  );

  if (error) {
    console.error({
      component: "useContractsByEmployee",
      errorDescription:
        "Error occurred while fetching data with MY_HR_GET_CONTRACTS_BY_EMPLOYEE",
      error,
    });
  }

  useSubscription(MY_HR_CONTRACTS_SUBSCRIPTION, {
    onData: useCallback(() => refetch(), [refetch]), // ✅ Uses stable function reference
    onError: (subscriptionError) => {
      console.error({
        component: "useContractsByEmployee",
        errorDescription:
          "Error occurred while subscribing to MY_HR_CONTRACTS_SUBSCRIPTION",
        error: subscriptionError,
      });
    },
  });

  return {
    data: data?.contractsByEmployee ?? [],
    loading,
    error,
  };
};

export default useMyHrContractsByEmployee;
